<style src="./ModalContent.scss" lang="scss"></style>
<template>
  <div class="modal-body ModalContent">  
    <div class="photos">
      <ModalZoom
        v-for="(photoPath, idx) in item.vehiclePhotoPath"
        :key="idx"
        :photo="sanitizePhotoPath(photoPath)" />
    </div>
    <div class="info">
      <div class="posutilizacao">
        <h2>Dados da Pós Utilização</h2>
        <table class="table">
          <tbody>
            <tr class="tableData">
              <td class="tableTitle">Data</td>
              <td class="tableValue">{{ DateBR(item.createdAt) }} - {{ HourBR(item.createdAt) }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Setor</td>
              <td class="tableValue">{{ item.parkName }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Valor R$</td>
              <td class="tableValue">{{ totalToCurrencyBR(item.amountPaid) }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Fiscal</td>
              <td class="tableValue">{{ item.employee }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Cód. Crédito</td>
              <td class="tableValue">{{ item.creditCode }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="vehicleinfo">
        <h2>Dados do Veículo</h2>
        <table class="table" v-if="!!vehicleDetails.uf && !isLoadingVehicleDetails">
          <tbody>
            <tr class="tableData">
              <td class="tableTitle">UF</td>
              <td class="tableValue">{{ vehicleDetails.uf || '-' }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Tipo</td>
              <td class="tableValue">{{ vehicleDetails.kindDescription || '-' }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Marca/Modelo</td>
              <td class="tableValue">{{ vehicleDetails.modelDescription || '-' }}</td>
            </tr>
            <tr class="tableData">
              <td class="tableTitle">Cor</td>
              <td class="tableValue">{{ vehicleDetails.colorDescription || '-' }}</td>
            </tr>
          </tbody>
        </table>

        <div v-show="isLoadingVehicleDetails">
          Buscando Informações do veículo
        </div>
        <div v-show="!vehicleDetails.uf && !isLoadingVehicleDetails">
          <h3>Veículo não identificado</h3>
          <p>Não encontramos esse veículo na base da SERPRO. Verifique se a placa informada corresponde ao da foto.</p>
        </div>
      </div>
    </div>

    <div class="history">
      <h2>Histórico</h2>
      <h3 v-if="isLoadingHistory">Carregando o histórico do veículo</h3>
      <table class="table table-striped" v-if="!isLoadingHistory">
        <tbody>
          <tr
            v-for="(credit, creditIdx) in creditHistory"
            :key="creditIdx"
          >
            <td>{{ credit.tariffName }}</td>
            <td>{{ DateBR(credit.createdAt) }}</td>
            <td>{{ HourBR(credit.createdAt) }}</td>
          </tr>
        </tbody>
      </table>

      <h2>Detalhes da Infração</h2>
      <table class="table">
        <tbody>
          <tr class="tableData">
            <td class="tableTitle">Situação do Condutor</td>
            <td class="tableValue">
              <span v-if="!hasPermissionToEditStaticData">{{ conductorStatus(form.condutorSituacao) }}</span>
              <select v-if="hasPermissionToEditStaticData" name="condutorSituacao" v-model="form.condutorSituacao">
                <option value="1">Ausente</option>
                <option value="5">Condutor não identificado</option>
              </select>
            </td>
          </tr>
          <tr class="tableData">
            <td class="tableTitle">Código da Infração</td>
            <td class="tableValue">
              <input v-if="hasPermissionToEditStaticData" type="text" v-model="form.infracaoCodigo" ref="inputInfracaoCodigo">
              <span v-if="!hasPermissionToEditStaticData">{{ form.infracaoCodigo }}</span>
            </td>
          </tr>
          <tr class="tableData">
            <td class="tableTitle">Código do Desdobramento</td>
            <td class="tableValue">
              <input v-if="hasPermissionToEditStaticData" type="text" v-model="form.infracaoDesdobramento" ref="inputInfracaoCodigo">
              <span v-if="!hasPermissionToEditStaticData">{{ form.infracaoDesdobramento }}</span>
            </td>
          </tr>
          <tr class="tableData">
            <td class="tableTitle">Observação{{ hasPermissionToEditStaticData }}</td>
            <td class="tableValue">
              <span v-if="!hasPermissionToEditStaticData">{{ form.observacao }}</span>
              <textarea v-if="hasPermissionToEditStaticData" v-model="form.observacao"></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ModalZoom from '../modal-zoom/ModalZoom.vue';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { toast } from '@/plugins/toast';

export default {
  components: {
    ModalZoom,
  },
  props: {
    item: {
      default: () => ({})
    },
  },
  data() {
    return {
      invalidReason: '',
      validState: 0,
      creditHistory: [],
      isLoadingVehicleDetails: false,
      isLoadingHistory: true,
      form: {
        infracaoCodigo: '',
        infracaoDesdobramento: '',
        observacao: '',
        condutorSituacao: '5'
      },
      vehicleDetails: {
        uf: null
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler(newItem) {
        const form = {
          infracaoCodigo: newItem.infracaoCodigo,
          infracaoDesdobramento: newItem.infracaoDesdobramento,
          observacao: newItem.observacao
        };
        this.$emit('input', form);
      }
    },
    item() {
      this.refreshVehicleInfo();
    }
  },
  computed: {
    hasPermissionToEditStaticData() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'serpro-edit-static-data',
        'SHOW',
      );
    },
  },
  mounted () {
    this.loadVehicleDetailsIfNecessary();
    this.loadVehicleHistory();
    this.setDefaultCodes();
  },
  methods: {
    conductorStatus(value) {
      return value === 1 ? 'Ausente' : 'Condutor não identificado';
    },
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      if (!dt) return null;
      return format(new Date(dt), 'dd/MM/yyyy', {
        locale: ptBR,
      });
    },
    HourBR(dt) {
      if (!dt) return null;
      return format(new Date(dt), 'HH:mm', {
        locale: ptBR,
      });
    },
    refreshVehicleInfo() {
      this.loadVehicleDetailsIfNecessary();
      this.loadVehicleHistory();
    },
    setDefaultCodes() {
      this.form.condutorSituacao = this.$store.state.SERPRO.defaultCondutorSituacao || '';
      this.form.infracaoCodigo = this.$store.state.SERPRO.defaultInfracaoCodigo || '';
      this.form.infracaoDesdobramento = this.$store.state.SERPRO.defaultInfracaoDesdobramento || '';
      let obs = '';
      if (this.$store.state.SERPRO.defaultObservacao) {
        obs = this.$store.state.SERPRO.defaultObservacao.replace('{creditcode}', this.item.creditCode)
      }
      this.form.observacao = obs;
    },
    loadVehicleDetailsIfNecessary() {
      if (!Object.hasOwn(this.item.vehicleDetails, 'uf')) {
        this.refreshVehicleDetails();
      } else {
        this.vehicleDetails = this.item.vehicleDetails;
      }
    },
    closeModal() {
      this.$emit('close-modal');
    },
    async refuseValidation() {
      this.validState = 2;
      await this.$nextTick();
      this.$refs.inputReason.focus();
    },
    cancelValidation() {
      this.validState = 0;
    },
    setValidState(state) {
      this.validState = state;
    },
    confirmValidation() {
      this.validState = 0;
    },
    confirmRefuse() {
      this.invalidReason = '';
      this.validState = 0;
    },
    sanitizePhotoPath(photoPath) {
      let photoPathSanitized = photoPath.replace(
        '/var/app/server-user-manager/notify-photos/',
        '',
      );
      photoPathSanitized = photoPath.replace(
        '/var/app/server-manager/notify-photos/',
        '',
      );

      const prodPath = 'https://peaceparking.app:3000/'
      return prodPath + photoPathSanitized;
    },
    async refreshVehicleDetails() {
      this.isLoadingVehicleDetails = true;
      this.vehicleDetails = { uf: null };

      try {
        const payload = {
          licencePlate: this.item.licencePlate,
        };
        const vehicleDetails = await this.$store.dispatch(
          'SERPRO/GetVehicleDetails',
          payload
        );
        this.vehicleDetails = vehicleDetails;
      } catch (error) {
        toast.error('Não foi possível pegar as informações do veículo');
      } finally {
        this.isLoadingVehicleDetails = false;
      }
    },
    async loadVehicleHistory() {
      this.isLoadingHistory = true;
      try {
        const payload = {
          creditId: this.item._id,
        };
        const creditHistory = await this.$store.dispatch(
          'GUARD-REQUEST/GetVehicleHistoryByCredit',
          payload
        );
        this.creditHistory = creditHistory.history;
      } catch (error) {
        toast.error('Não foi possível carregar o histórico do veículo');
      } finally {
        this.isLoadingHistory = false;
      }
    }
  },
};
</script>
